import { render, staticRenderFns } from "./chatMessage.vue?vue&type=template&id=5fedf73f"
import script from "./chatMessage.vue?vue&type=script&lang=js"
export * from "./chatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports